import * as yup from 'yup'
import { CompanyDto } from './companyDto'
import { CompanyAddressDto } from './companyAddressDto'
import { VehicleDto } from './vehicle'
import { InboundTripDto } from './inboundTripDto'

export class InboundTripPAPSDto {
  inboundTripPAPSGuid?: string = undefined
  numberOfVehiclesInPAPS?: number = undefined // Not sure if needed
  papsNumber?: string = undefined
  exporterCompany?: CompanyDto = undefined
  buyerCompany?: CompanyDto = undefined
  vehicleDestinationCompany?: CompanyDto = undefined
  vehicleDestinationCompanyAddress?: CompanyAddressDto = undefined
  titleDestinationCompany?: CompanyDto = undefined
  titleDestinationCompanyAddress?: CompanyAddressDto = undefined
  proFormaFileName?: string = undefined
  foreignShippersFileName?: string = undefined
  signedForeignShippersFileName?: string = undefined
  invoiceTotal?: number = undefined
  totalWeightLbs?: number = undefined
  grossWeightKg?: number = undefined
  isLocked: boolean = false
  vehicles?: VehicleDto[] = undefined
  inboundTrip?: InboundTripDto = undefined
  abramsAutoInvoiceFileName?: string = undefined
}

export const inboundTripPAPSValidationSchema = yup.object<InboundTripPAPSDto>({
  papsNumber: yup.string().required('PAPS Number is required.'),
  exporterCompany: yup.object().required('Exporter Company is required.'),
  vehicleDestinationCompany: yup.object().required('Vehicle Destination Company is required.'),
  vehicleDestinationCompanyAddress: yup.object().required('Vehicle Destination Company Address is required.'),
  titleDestinationCompany: yup.object().required('Title Destination Company is required.'),
  titleDestinationCompanyAddress: yup.object().required('Title Destination Company Address is required.')
})
